export default __webpack_public_path__ + "c01f7621623dccd8174162aeab523d44.svg";